<template>
  <div>
    <issue-filter @change="onChange" />
    <br />
    <issue-response-average :filter-form="filterForm" />
  </div>
</template>
<script>
import IssueFilter from '@/pages/data/issue/components/IssueFilter';
import IssueResponseAverage from '@/pages/data/issue/components/IssueResponseAverage';

export default {
  components: { IssueFilter, IssueResponseAverage },
  data() {
    return {
      filterForm: {
        begin_date: null,
        end_date: null
      }
    };
  },
  methods: {
    onChange(checkedDate, checkedTeams) {
      this.filterForm = {
        begin_date: checkedDate[0].format('YYYY-MM-DD'),
        end_date: checkedDate[1].format('YYYY-MM-DD'),
        teams: checkedTeams
      };
    }
  }
};
</script>
